import React from 'react';
import { Button } from 'primereact/button';
import useFeedbackFormReport from './hooks/useFeedbackFormReport';
import FeedbackFormReportTable from './components/FeedbackFormReportTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportTechnicalSupportFeedbackFormReportToExcelQuery } from '../../../api/endpoints/technicalSupportRequest';

const FeedbackFormReportPage = () => {
    const { th } = useLanguage();

    const { items, totalCount, isLoading, lazyParams, activeFilters, filterOptions, sortField, sortOrder, exportParams, onPage, onSort, handleFilterChange, initFilters } = useFeedbackFormReport();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('feedbackFormReport.title')}</h1>
                <div className="flex gap-2">
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportTechnicalSupportFeedbackFormReportToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel={th('common.export')}
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'geri_bildirim_formu_raporu.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>

            <FeedbackFormReportTable
                items={items}
                totalCount={totalCount}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                filterOptions={filterOptions}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />
        </div>
    );
};

export default FeedbackFormReportPage;
